import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import { PositionedOverlay, Image, Ribbon } from 'reaxl';
import { useFeatures } from '@atc/features';

/**
 *   Molecule to encapsulate standard PositionOverlay + Ribbon + kbb Image logic
 *
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function KBBDealIndicator(_ref) {
  let {
    lazyLoad = true,
    flat = false,
    className,
    pricingDetail,
    position = 'topRight',
    logoSize = 'default'
  } = _ref;
  const {
    kbb_price_rating: [enableKBBDealIndicator]
  } = useFeatures(['kbb_price_rating']);
  const kbbLogo = {
    alt: 'KBB.com Price Advisor',
    src: 'https://www.autotrader.com/content/dam/autotrader/additionalresources/kbb_logo.svg'
  };
  const {
    dealIndicator
  } = pricingDetail;
  const positionLeft = position === 'topLeft';
  const invertPosition = positionLeft ? 'topRight' : 'topLeft';
  const isSmallLogo = logoSize === 'small';
  const ribbonProps = dealIndicator && {
    position: positionLeft ? 'left' : 'right',
    label: `${dealIndicator.toUpperCase()} PRICE`,
    uiContext: `${dealIndicator.toLowerCase()}-price`
  };
  const styles = {
    [positionLeft ? 'left' : 'right']: '17px'
  };
  const renderKBBImage = () => {
    const imageClass = positionLeft ? 'order-1' : 'order-2';
    return /*#__PURE__*/_jsx(Image, {
      className: clsx('media-gallery-viewer', imageClass),
      style: styles,
      lazyload: lazyLoad,
      height: 34,
      width: 25,
      ...kbbLogo
    });
  };
  const flatClasses = clsx('padding-left-1 text-bold', {
    'padding-top-1 text-size-200': !isSmallLogo,
    'text-size-300': isSmallLogo,
    'text-success': dealIndicator && dealIndicator.toUpperCase() === 'GREAT',
    'text-subdued-lighter': dealIndicator && dealIndicator.toUpperCase() === 'GOOD'
  });
  if (!enableKBBDealIndicator) {
    return null;
  }
  return !flat ? /*#__PURE__*/_jsxs(PositionedOverlay, {
    className: clsx('display-flex', className),
    shrinkwrap: false,
    children: [/*#__PURE__*/_jsx(PositionedOverlay.Base, {
      children: /*#__PURE__*/_jsx(Ribbon, {
        className: clsx('text-size-200 margin-vertical-1', {
          'padding-left-3': !positionLeft,
          'padding-right-3': positionLeft,
          flat
        }),
        ...ribbonProps
      })
    }), /*#__PURE__*/_jsx(PositionedOverlay.Anchor, {
      position: invertPosition,
      offsetTop: 0,
      children: renderKBBImage()
    })]
  }) : /*#__PURE__*/_jsxs("div", {
    className: clsx('display-flex flex-nowrap', className, {
      'align-items-center': isSmallLogo
    }),
    "data-cmp": "KBBDealIndicator",
    children: [/*#__PURE__*/_jsx(Image, {
      style: styles,
      lazyload: lazyLoad,
      height: isSmallLogo ? 20 : 24,
      width: 18,
      ...kbbLogo
    }, "KBBDealIndicator-image"), /*#__PURE__*/_jsxs("span", {
      className: flatClasses,
      children: [dealIndicator.toUpperCase(), ' ', "PRICE"]
    })]
  });
}
export default KBBDealIndicator;